import _asyncToGenerator from "D:/workBag/projectDemo/lindoSupport/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.json.stringify.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-73259679"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "height": "100%",
    "width": "100%"
  }
};
var _hoisted_2 = {
  class: "div-body",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
var _hoisted_3 = {
  class: "body-item",
  style: {
    "margin-bottom": "50px"
  }
};
var _hoisted_4 = {
  class: "span-tile"
};
var _hoisted_5 = {
  class: "span1"
};
var _hoisted_6 = {
  class: "span2"
};
var _hoisted_7 = ["innerHTML"];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "flex": "1"
    }
  }, null, -1);
});

import { reactive, ref, toRefs } from "@vue/reactivity";
import { formateDate } from "@/utils/index";
import { useRoute } from "vue-router";
import { getFAQById } from "@/api/lindo";
import { escape2Html } from "@/utils/index";
import Footer from "../components/Footer";
import { onMounted } from "@vue/runtime-core";
export default {
  setup: function setup(__props) {
    var route = useRoute();
    var data = reactive({
      tableData: {}
    });
    var vloading = ref(false);

    var _toRefs = toRefs(data),
        tableData = _toRefs.tableData;

    var getFAQByIdList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ret;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vloading.value = true;
                _context.next = 3;
                return getFAQById(route.params);

              case 3:
                ret = _context.sent;
                data.tableData = ret;
                window.document.title = data.tableData.title;
                data.tableData.message = escape2Html(JSON.parse(JSON.stringify(ret.message)));
                vloading.value = false;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getFAQByIdList() {
        return _ref.apply(this, arguments);
      };
    }();

    getFAQByIdList();
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(tableData).title), 1), _createElementVNode("span", _hoisted_6, "Last Updated: " + _toDisplayString(_unref(formateDate)(_unref(tableData).time)), 1)])), [[_directive_loading, vloading.value]]), _createElementVNode("div", {
        class: "span-body",
        innerHTML: _unref(tableData).message
      }, null, 8, _hoisted_7)]), _hoisted_8])]);
    };
  }
};